import {post} from '@/utils/request';
import {erpserver,attendanceserver} from '@/utils/baseUrl';

//考勤人员信息列表
export async function getKqRyList(params) {
    return post(attendanceserver+'/kq/getKqRyList', params, true)
}
//考勤方案列表
export async function getKqList(params) {
    return post(attendanceserver+'/kq/getKqList', params, true)
}
//编辑保存用户人员信息
export async function saveKqRy(params) {
    return post(attendanceserver+'/kq/saveKqRy', params, true)
}
//班次列表
export async function getbcList(params) {
    return post(attendanceserver+'/kq/getbcList', params, true)
}
//获取岗位列表
export async function positionlist(params) {
    return post(attendanceserver+'/attendence/positionlist', params, true)
}